const TASK_AMENDS_KEY_PREFIX = "tasks."

export function getTaskAmendsKey(task = {}) {
    return buildTaskAmendsKey(getTaskIdentifierForAmendsKey(task))
}

export function buildTaskAmendsKey(taskId) {
    if (!taskId) return null
    return `${TASK_AMENDS_KEY_PREFIX}${taskId}`
}

export function getTaskIdentifierForAmendsKey(task = {}) {
    if (!task) return null
    if (task?.isHeader) return task?.headerTaskId ?? task?.taskId ?? task?.id ?? null
    return task?.temporaryTaskId ?? task?.taskId ?? null
}

export function getTaskId(task = {}) {
    return task?.temporaryTaskId || task?.taskId || null
}

export function getTaskIdFromAmendsKey(amendsKey = "") {
    if (typeof amendsKey !== "string" || !amendsKey.startsWith(TASK_AMENDS_KEY_PREFIX)) return null
    const taskId = amendsKey.slice(TASK_AMENDS_KEY_PREFIX.length)
    return taskId || null
}

export function isTaskAmendsKey(amendsKey = "") {
    return Boolean(getTaskIdFromAmendsKey(amendsKey))
}
